import moment from 'moment';
const i18nLanguageToMomentLocale = {
    en: 'en-US',
    he: 'he',
};
export const setMomentLocaleOnLanguageChange = (i18nLanguage) => {
    moment.locale(i18nLanguageToMomentLocale[i18nLanguage]);
};
